import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { MemberModel, TeamModel, TeamRoleModel, UserTeamModel } from '../../../../models/team-permissions.model';

export interface TeamPermState extends EntityState<TeamModel> {
    currentUser: UserTeamModel;
    selectedTeam: TeamModel;
    selectedTeamRole: TeamRoleModel;

    detailsForm: any;
    updateTeamListing: boolean;
    selectedMember: MemberModel;
    updateMemberListing: boolean;
    updateAddMemberListing: boolean;
    updateRoleListing: boolean;

    selectedGuid: string;
    errorLog: {timeStamp: Date, log: string}[];
    totalRecords: number,
    requiresUpdate: boolean;
}

export const teamPermAdapters: EntityAdapter<TeamModel> = createEntityAdapter<TeamModel>({
    selectId: a => a.app_mst_grp_hdr.guid.toString()
});

export const initialState: TeamPermState = teamPermAdapters.getInitialState({
    currentUser: null,
    selectedTeam: null,
    selectedTeamRole: null,
    detailsForm: null,
    updateTeamListing: false,
    selectedMember: null,
    updateMemberListing: false,
    updateAddMemberListing: false,
    updateRoleListing: false,

    selectedGuid: null,
    errorLog: [],
    totalRecords: 0,
    requiresUpdate: false,
    viewCache: null
})
